import {useCallback} from 'react'
import {useDispatch} from 'react-redux'
import config from '../../config'
import {GET_CURRENT_PAGE, GET_CURRENT_ENV} from './actionTypes'
// import fetchData, {fetchContent} from '../../utils/fetch-data'
// import {getCookie} from '../../utils/cookie'
// import getCityAliasAPI from '../../utils/get-city-alias-api'

// const homePage = (process.env.NODE_ENV === 'development') ?
//   false : window.theme.isHomePage
// const groupName = !homePage ? window.theme.cityAlias : false


const devEnv = process.env.NODE_ENV === 'development'

const homePage = devEnv ? false : window.theme.isHomePage

const cityPage = devEnv ? false : window.theme.isCityPage

const groupPage = devEnv ? true : !homePage && !cityPage

// const groupName = !homePage ? window.theme.cityAlias : false

const currentPage = () => {
  if (devEnv) {
    return config.currentPage
  }
  if (homePage) {
    return 'homePage'
  }
  if (cityPage) {
    return 'cityPage'
  }
  if (groupPage) {
    return 'groupPage'
  }
}



const useCurrentPageActions = () => {
  const dispatch = useDispatch()
  const getCurrentPage = useCallback(() => {
    dispatch({
      type: GET_CURRENT_PAGE,
      currentPage: currentPage(),
    })
  }, [dispatch])
  const getCurrentEnv = useCallback(() => {
    dispatch({
      type: GET_CURRENT_ENV,
      currentEnv: process.env.NODE_ENV,
    })
  }, [dispatch])
  return {getCurrentPage, getCurrentEnv}
}

export default useCurrentPageActions
